/* eslint-disable no-param-reassign */
import Cookies from 'js-cookie';
import FetchExperimentWithIdentifier from './fetch-experiment-with-identifier';
import accessToken from '../../accessToken';

type FetchExperimentProps = Parameters<typeof FetchExperimentWithIdentifier>[0];
type GetAssignedBucketProps = Omit<FetchExperimentProps, 'identifier'> &
  Partial<Pick<FetchExperimentProps, 'identifier'>>;

let fetchExperimentWithIdentifier = (
  props: Parameters<typeof FetchExperimentWithIdentifier>[0]
) => FetchExperimentWithIdentifier(props);

export function UpdateFetchExperiment(
  func: typeof fetchExperimentWithIdentifier
) {
  fetchExperimentWithIdentifier = func;
}

const GetAssignedBucket = async (props: GetAssignedBucketProps) => {
  const { user } = accessToken() || {};
  const fetchProps: FetchExperimentProps = {
    ...props,
    identifier: props.identifier || user?.user_id
  };

  const { experimentName } = props;
  const cachedCookie = Cookies.get(experimentName);
  const hasCachedCookie = !!cachedCookie;

  if (hasCachedCookie) {
    return {
      assignedBucket: cachedCookie,
      experimentName
    };
  }

  if (!user?.user_id) {
    return {
      assignedBucket: 'control',
      experimentName,
      hasErrors: false
    };
  }

  return fetchExperimentWithIdentifier(fetchProps);
};

export default GetAssignedBucket;
